export const getStartOfDay = date => new Date(date.setUTCHours(0, 0, 0, 0));

export const getStartOfWeek = date => {
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
  const startOfWeek = new Date(date.setDate(diff));
  return getStartOfDay(startOfWeek);
};

export const getStartOfMonth = date => {
  const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)

  return getStartOfDay(startOfMonth);
};

export const getStartOfQuarter = date => {
  // Determine the current quarter
  const currentMonth = date.getMonth();
  const startMonthOfQuarter = currentMonth - (currentMonth % 3);

  const startOfQuarter = new Date(date.getFullYear(), startMonthOfQuarter, 1);
  return getStartOfDay(startOfQuarter);
};

export const getStartOfHalfYear = date => {
  // Determine the current half year
  const currentMonth = date.getMonth();
  const startMonthOfHalfYear = currentMonth - (currentMonth % 6);

  const startOfHalfYear = new Date(date.getFullYear(), startMonthOfHalfYear, 1);
  return getStartOfDay(startOfHalfYear);
};

export const getStartOfYear = date => {
  const startOfYear = new Date(date.getFullYear(), 0, 1);
  return getStartOfDay(startOfYear);
};
